// singleton
(function (window, $) {
    window.TruncateToHeight = (function () {
        var instance;

        function init() {
            var limit = 1000; // how many characters to remove (actually loops) before we throw an error

            var contentContainers = []; // list of content containers
            var heightContainers = []; // list of containers to constrain by height
            var clones = []; // list of original content, used when reprocessing

            // helpers

            var parseHTML = function (str) {
                var tmp = document.implementation.createHTMLDocument();
                tmp.body.innerHTML = str;
                return tmp.body.children;
            };

            var sethtml = function (elementId, html) {
                document.getElementById(elementId).innerHTML = html;
            };

            var gethtml = function (elementId) {
                return document.getElementById(elementId).innerHTML.trim();
            };

            var getScrollHeight = function (elementId) {
                return document.getElementById(elementId).scrollHeight;
            };

            var getClientHeight = function (elementId) {
                return document.getElementById(elementId).clientHeight;
            };

            var replaceParagraphTags = function (html) {
                // regexes
                var openParagraphRegEx = /<p(.*?)>/gi;
                var closeParagraphRegEx = /<\/p>/gi;
                html = html.replace(openParagraphRegEx, '');
                html = html.replace(closeParagraphRegEx, '<br><br>');
                return html;
            };

            var getHeightElementId = function (elementId) {
                var idx = contentContainers.indexOf(elementId);
                return heightContainers[idx];
            };

            // main methods to manage initial state of element data

            var elementExists = function (elementId) {
                return contentContainers.indexOf(elementId);
            };

            var addHeightElement = function (elementId) {
                heightContainers.push(elementId);
            };

            var addContentElement = function (elementId) {
                contentContainers.push(elementId);
            };

            var addClone = function (elementId) {
                clones.push(gethtml(elementId));
            };

            // guts

            var fixContainer = function (elementId) {
                var heightElementId = getHeightElementId(elementId);
                document.getElementById(elementId).style.display = 'inline';
                document.getElementById(heightElementId).style.overflow = 'hidden';
                document.getElementById(heightElementId).style.maxHeight =
                    document.getElementById(heightElementId).style.height;
            };

            var clearContent = function (elementId) {
                sethtml(elementId, '');
            };

            var appendContent = function (elementId) {
                var idx = contentContainers.indexOf(elementId);
                var heightElementId = getHeightElementId(elementId);

                //The following regEx replacement routiens raplace the symbols "$", "(", and ")", with their HTML codes so that they will work with the jQuery selector.
                var html = clones[idx]
                    .replace(/\$/g, '&#36;')
                    .replace(/\(/g, '&#40;')
                    .replace(/\)/g, '&#41;');
                var nodes;
                try {
                    nodes = $(html);
                } catch (e) {
                    //In case parsing the text fails, just assume its a text node;
                    nodes = {};
                    nodes.length = false;
                }
                var element = $('#' + elementId);

                if (nodes.length) {
                    var htmlSnippet = '';
                    var nodeType = 0;
                    for (var i = 0; i < nodes.length; i++) {
                        htmlSnippet = '';
                        nodeType = nodes[i].nodeType.toString();
                        switch (nodeType) {
                            case '1':
                                htmlSnippet = nodes[i].outerHTML;
                                break;
                            case '3':
                                htmlSnippet = nodes[i].textContent;
                                break;
                        }
                        htmlSnippet = replaceParagraphTags(htmlSnippet);
                        $(element).append($.trim(htmlSnippet));
                        if (getScrollHeight(heightElementId) > getClientHeight(heightElementId)) {
                            break;
                        }
                    }
                } else {
                    $(element).append($.trim(html));
                }
            };

            var sliceContent = function (elementId) {
                var cnt = 0; // counter just to prevent long runs or infinite loops
                var heightElementId = getHeightElementId(elementId);
                let newContent;

                let parent = $('#' + heightElementId);
                let child = $(parent.children()[0]);

                if (child) {
                    while (Math.floor(child.height()) > Math.floor(parent.height())) {
                        cnt++;
                        let el = document.getElementById(elementId);
                        if (el) {
                            let childNodes = el.childNodes;
                            let childNode = childNodes[childNodes.length - 1];

                            let nodeType = childNode.nodeType;
                            let text;
                            let newText;

                            if (nodeType === 1) {
                                text = childNode.textContent.trim();
                                if (text.length > 0) {
                                    if (text.substr(-3) === '...') {
                                        text = text.slice(0, text.length - 3);
                                    }
                                    newText = text.slice(0, text.length - 1) + '...';
                                    $(childNode).text(newText);
                                }
                            }

                            if (nodeType === 3) {
                                text = childNode.nodeValue;
                                if (text.length > 0) {
                                    if (text.substr(-3) === '...') {
                                        text = text.slice(0, text.length - 3);
                                    }
                                    newText = text.slice(0, text.length - 1) + '...';
                                    childNode.nodeValue = newText;
                                }
                            }

                            if (text === '') {
                                $(childNode).remove();
                            }

                            /*
                            var currentContent = el.innerHTML;
                            currentContent = $.trim( currentContent );
                            if(currentContent.substr( currentContent.length - 3) === '...'){
                                currentContent = currentContent.slice(0, currentContent.length-3);
                            }

                            if(currentContent.substr(-1) === '>'){

                            }

                            newContent = currentContent.slice(0, currentContent.length-1) + '...';
                            el.innerHTML = newContent;
                            // console.log('newContent', newContent);
                            */
                        }
                        if (cnt > limit) {
                            if (window.console) {
                                console.error('TruncateToHeight sliceContent broke!');
                            }
                            break;
                        }
                    }
                }
            };

            var slimDown = function (elementId) {
                var nodes = document.getElementById(elementId).childNodes;
                var nodeToModify = document.getElementById(elementId).childNodes[nodes.length - 1];
                //nodeToModify.nodeValue = nodeToModify.textContent.substring(0, nodeToModify.textContent.length-10).trim(); // -10 is to add (or remove rather) a few characters as a buffer
                nodeToModify.nodeValue = nodeToModify.textContent
                    .substring(0, nodeToModify.textContent.length)
                    .trim();
            };

            var removeTrailingBreaks = function (elementId) {
                var cnt = 0;
                var element = $('#' + elementId);
                var nodes = $(element[0].childNodes);
                while (nodes[nodes.length - 1].outerHTML === '<br>') {
                    cnt++;
                    nodes = nodes.slice(0, -1);
                    if (cnt > 100) {
                        if (window.console) {
                            console.error('TruncateToHeight:removeTrailingBreaks');
                        }
                        break;
                    }
                }
                $(element).html(nodes);
            };

            var appendDotDotDot = function (elementId) {
                var nodes = document.getElementById(elementId).childNodes;
                var nodeToModify = document.getElementById(elementId).childNodes[nodes.length - 1];
                var chars = nodeToModify.textContent.trim();
                var lastChar = chars.substring(chars.length - 1, chars.length);
                if (/^(\,|\.|\?|\!)$/i.test(lastChar)) {
                    // nodeToModify.nodeValue = nodeToModify.textContent.substring(0, nodeToModify.textContent.length) + ' ... ';
                } else {
                    // nodeToModify.nodeValue = nodeToModify.textContent.substring(0, nodeToModify.textContent.length) + '... ';
                }
            };

            function getElements() {
                console.log('getElements', contentContainers);
                return contentContainers;
            }

            function getClones() {
                console.log('getClones', clones);
                return clones;
            }

            function updateAll() {
                for (var i = 0; i < contentContainers.length; i++) {
                    updateElement(contentContainers[i]);
                }
                return this;
            }

            function updateElement(elementId) {
                if (contentContainers.indexOf(elementId) >= 0) {
                    // do the truncate ish
                    var el = document.getElementById(elementId);
                    if (el) {
                        fixContainer(elementId);
                        clearContent(elementId);
                        appendContent(elementId);
                        sliceContent(elementId);
                        slimDown(elementId);
                        removeTrailingBreaks(elementId);
                        appendDotDotDot(elementId);
                    }
                } else {
                    if (window.console) {
                        console.error(
                            'You tried to update an element [' +
                                elementId +
                                '] that has not been initialized.',
                        );
                    }
                }
                return this;
            }

            function truncate(obj) {
                // quick validation
                var allGood = true;
                var errorMsg = '';
                if (!arguments.length || !typeof arguments[0] === 'object') {
                    obj = {};
                    if (window.console) {
                        console.error('TruncateToHeight: You did not pass in an object.');
                    }
                }

                // user defined
                var heightElementId = obj.hasOwnProperty('heightElementId')
                    ? obj.heightElementId
                    : ''; // element ID with text/html to truncate
                var contentElementId = obj.hasOwnProperty('contentElementId')
                    ? obj.contentElementId
                    : ''; // DIV element ID, (parent or self) to reference for height restrictions (used for truncation), must have display: inline; but there's a fixContent method that does this for you

                limit = obj.hasOwnProperty('limit') ? obj.limit : 1000;

                if (!document.getElementById(contentElementId)) {
                    allGood = false;
                    errorMsg =
                        contentElementId == ''
                            ? 'You forgot to specify contentElementId.'
                            : 'The element ' + contentElementId + ' does not exist.';
                }

                if (!document.getElementById(heightElementId)) {
                    allGood = false;
                    errorMsg =
                        heightElementId == ''
                            ? 'You forgot to specify heightElementId.'
                            : 'The element ' + heightElementId + ' does not exist.';
                }

                if (allGood) {
                    // keep a record if it doesn't exist
                    if (elementExists(obj.contentElementId) === -1) {
                        addHeightElement(obj.heightElementId);
                        addContentElement(obj.contentElementId);
                        addClone(obj.contentElementId);
                    }
                    // update it
                    updateElement(obj.contentElementId);
                } else {
                    if (window.console) {
                        console.error('Error initializing TruncateToHeight: ' + errorMsg);
                    }
                }
                return this;
            }

            // update when window resize
            var resizeTimer;
            $(window).on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    updateAll();
                }, 250);
            });

            // update when window is loaded (for slow loading ish)
            $(function () {
                updateAll();
            });

            return {
                // debug methods
                //getElements : getElements,
                //getClones : getClones,
                // release these to public
                updateElement: updateElement, // runs/updates a single element
                updateAll: updateAll, // updates all existing elements
                truncate: truncate, // initialize & run against the element
            };
        }
        return {
            getInstance: function () {
                if (!instance) {
                    instance = init();
                }
                return instance;
            },
        };
    })();

    // set var immediately to instance
    TruncateToHeight = TruncateToHeight.getInstance();
})(window, jQuery);

/**
 * HOW TO USE:
 *
 * REQUIRED: element to be truncated requires a parent w/ height, max-height, overflow: hidden
 * TruncateToHeight.truncate({
 *      heightElementId : 'theElementId-that-stores-a-fixed-height', // parent
 *      contentElementId : 'theElementId-to-truncate' // element to be truncated
 * });
 *
 * Optional: update an existing object already truncated
 * TruncateToHeight.updateElement('theContentElementId-see-above');
 *
 * Optional: update all existing objects already truncated
 * TruncateToHeight.updateAll();
 *
 * These should be called after jQuery is ready, or inside $(window.load(function(){ ... here ... });
 *
 *
 * Not sure if the object exists? Be safe:
 *
 * if(typeof TruncateToHeight !== 'undefined'){
 *      ... put your stuff here ...
 * }
 * (better yet, update the view to include the TruncateToHeight.js file)
 *
 */
